import { render } from "./WCItemModifierItemGroup.vue?vue&type=template&id=5b7b571a&scoped=true"
import script from "./WCItemModifierItemGroup.vue?vue&type=script&lang=js"
export * from "./WCItemModifierItemGroup.vue?vue&type=script&lang=js"

import "./WCItemModifierItemGroup.vue?vue&type=style&index=0&id=5b7b571a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b7b571a"]])

export default __exports__